import { activationHelpId, ctaEnterZifyId } from "@/assets/googleTrackIds";
import { Button, LegacyCard, Space, Typography } from "@payping/web-components";
import { useAppTranslation } from "@/utils/useAppTranslation";

const ChangeAdvancedSettlement = () => {
  const { t } = useAppTranslation();

  return (
    <LegacyCard.Ant>
      <LegacyCard.Meta
        title={t("settlement.attention")}
        description={
          <Space orientation={"vertical"} size={"large"} className={"tw:w-full"}>
            <Typography.Text>{t("settlement.banner.desc")}</Typography.Text>
            <Space orientation={"horizontal"}>
              <a href={"https://zify.ir/panel/"} target={"_blank"} rel="noreferrer" data-google-track={ctaEnterZifyId}>
                <Button type={"primary"}>{t("settlement.banner.loginZify")}</Button>
              </a>
              <a
                href={"https://payping.ir/blog/%D8%B2%DB%8C%D9%81%D8%A7%DB%8C-%DA%86%DB%8C%D8%B3%D8%AA%D8%9F/"}
                target={"_blank"}
                rel="noreferrer"
                data-google-track={activationHelpId}
              >
                <Button variant={"link"}>{t("settlement.banner.zifyStepHelp")}</Button>
              </a>
            </Space>
          </Space>
        }
      />
    </LegacyCard.Ant>
  );
};
export default ChangeAdvancedSettlement;
